<template>
  <o-card :title="$t('core.support')">
    <div class="mt-1 font-weight-bold mb-3">
      <span v-html="$t('core.support_text').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')"></span>
    </div>

    <b-row v-if="support_email || support_phone">
      <b-col>
        <div>
          {{ $t('core.email') }} :
          <a :href="'mailto:' + support_email">
            {{ support_email }}
          </a>
        </div>
        <div>
          {{ $t('core.phone') }} :
          <a :href="'tel:' + support_email">
            {{ support_phone }}
          </a>
        </div>
      </b-col>
    </b-row>
  </o-card>
</template>

<script>
  export default {
    data: () => ({
      support_email: null,
      support_phone: null
    }),
    mounted () {
      this.support_email = window.config.support_email
      this.support_phone = window.config.support_phone
    }
  }
</script>
